import { render, staticRenderFns } from "./index.vue?vue&type=template&id=402c866a&scoped=true"
var script = {}
import style0 from "./index.vue?vue&type=style&index=0&id=402c866a&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "402c866a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\GitHub\\ita.GroupTravel.Website\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('402c866a')) {
      api.createRecord('402c866a', component.options)
    } else {
      api.reload('402c866a', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=402c866a&scoped=true", function () {
      api.rerender('402c866a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/GithubCorner/index.vue"
export default component.exports